import React from 'react'

const style = {
    fontSize: '12.25px',
}

const Header = (props) => {
    const { logout, isFetching, isNavigationCollapsed, user, toggleNavigation } = props
    return (
        <div className={`top-navigation ${isNavigationCollapsed ? 'collapsed' : 'expanded'}`}>
            <div className="top-navigation-logo">
                <img src="/asset/image/logo-white.svg" alt="Logo"/>
            </div>
            <div className="left-nav">
                <ul>
                    <li>
                        <a onClick={toggleNavigation}><i className="fa fa-bars"/></a>
                    </li>
                </ul>
            </div>
            <div className="right-nav">
                <ul>
                    {isFetching && <li className="no-hover"><a><i className="fa fa-spinner iconRotate"/></a></li>}
                    <li className="no-hover" style={style}>Welcome {user.firstName}</li>
                    <li><a onClick={logout}><i className="fa fa-power-off"/></a></li>
                </ul>
            </div>
        </div>

    )
}


export default Header



// WEBPACK FOOTER //
// ./src/modules/layout/component/Header.js